import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AbilityModule } from 'ability';
import { I18NextModule, I18NextPipe } from 'angular-i18next';
import { MbsUiKitModule } from 'mbs-ui-kit';
import { AlertType } from 'mbs-ui-kit/alert/alert.model';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { ActivatedRoute } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'remote-connection-install-update-modal',
  templateUrl: './remote-connection-install-update-modal.component.html',
  standalone: true,
  imports: [CommonModule, I18NextModule, FormsModule, ReactiveFormsModule, MbsUiKitModule, AbilityModule, NgbTooltipModule]
})
export class RemoteConnectionInstallUpdateModalComponent implements AfterViewInit {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  public readonly alertType = AlertType;

  public isInstallMode: boolean;
  public computerName: string;
  public isMBSMode: boolean;

  constructor(
    private i18n: I18NextPipe,
    private auth: AuthFacade,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {
    this.isMBSMode = this.auth.isMBSMode;
  }

  public get title(): string {
    return this.getI18Text('connectTo', this.computerName);
  }

  public get okButton(): string {
    return this.getI18Text(this.isInstallMode ? 'installAndConnect' : 'updateAndConnect');
  }

  ngAfterViewInit(): void {
    if (this.baseModal.data) {
      this.isInstallMode = this.baseModal.data.isInstallMode;
      this.computerName = this.baseModal.data.computerName;
      this.cdr.detectChanges();
    }
  }

  public onCloseButtonClick() {
    if (this.route.snapshot.queryParams.inApp === 'true') {
      return void window.close();
    }

    this.baseModal.close()
  }

  private getI18Text(key: string, param = '') {
    return this.i18n.transform(`shared:computers.modals.${key}`, param ? { param } : {});
  }
}
